import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  listItem: {
    color: "#eee",
    borderLeft: "3px solid transparent",
    padding: "11px 27px !important",
    transition: "0.3s",
    lineHeight: "24px",
    cursor: "pointer",

    "&:hover": {
      color: "#fff",
      borderColor: theme.palette.primary.main,
      backgroundColor: "rgba(255,255,255,0.025)",
    },
  },
  listItemClosed: {
    padding: "11px 27px 11px 23px !important",
  },
  listItemClosedInSubmenu: {
    padding: "11px 27px 11px 33px !important",
  },
  listItemSelected: {
    color: "#fff",
    borderColor: theme.palette.primary.main,
    backgroundColor: "rgba(255,255,255,0.05) !important",
  },
  listItemText: {
    color: "#eee",
    textAlign: "left",
    minWidth: 217,
    opacity: 1,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuClosed: {
    opacity: 0,
  },
  listItemIconBefore: {
    marginRight: 12,
    color: "#eee",
    minWidth: "unset",
    fontSize: 16,
    fontWeight: 400,
    "& svg": {
      width: 25,
      height: 25,
      marginLeft: -5,
    },
  },
  indented: {
    paddingLeft: "55px !important",
  },
}));

export default useStyles;
